import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  selector: 'app-e-spc',
  templateUrl: './e-spc.component.html',
  styleUrls: ['./e-spc.component.css']
})
export class ESpcComponent implements OnInit {

  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Input Variables
  TINInput: any = "";
  AgentInput: any = "";
  SearchTypeInput: any = "";
  FormTypeInput: any = "";

  //UI View Variables
  TINView: any = "";
  ItGrpCdView: any = "";
  TaxpNameView: any = "";
  SearchTypeView: any = "";

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionLanguage: any = "";

  //Array Variables
  AgentList: any = new Array;

  //Datatable
  displayedColumns = ['jenisborang', 'tahun', 'action'];

  //Open Window
  openedWindowStatus: any = null;

  constructor(private apiServices: ApiservicesService, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionLanguage = sessionStorage.getItem('Language');
  }
  onChangeIDType() {
    this.SearchStatus = false;
    this.ResetValue();
  }
  ResetValue() {
    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SearchTypeView = "";

    this.TINInput = "";
    this.AgentInput = "";
  }
  async Submit(SearchType: any, TIN: any) {
    this.LoaderStatus = true;
    if (SearchType === "" || TIN === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      this.SearchTypeView = SearchType;
      let Params;
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN),
          "formType": "SPCS"
        };
      }
      else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN),
          "formType": "SPCM"
        };
      }
      const result = await this.apiServices.SharedIntegrationDetail(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.GetAgent(this.SessionFirmID);
        this.TINView = result.taxPayer.iT_Ref_No;
        this.ItGrpCdView = result.taxPayer.jenisFail;
        this.TaxpNameView = result.taxPayer.nama;
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
  }
  async Login(SearchType: any, TIN: any, AgentID: any) {
    this.LoaderStatus = true;
    if (AgentID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params;
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN),
          "staffID": Number(this.SessionStaffID),
          "taxAgentID": Number(AgentID),
          "formType": "SPCS",
          "signature": sessionStorage.getItem('token'),
          "language": this.SessionLanguage
        };
      } else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN),
          "staffID": Number(this.SessionStaffID),
          "taxAgentID": Number(AgentID),
          "formType": "SPCM",
          "signature": sessionStorage.getItem('token'),
          "language": this.SessionLanguage
        };
      }
      const result = await this.apiServices.SharedIntegrationLogin(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.openWindow(result.url);
        //window.open(result.url, "_blank");
        this.LoaderStatus = false;
      }
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  Semula() {
    this.LoaderStatus = false;
    this.SearchStatus = false;
    this.AlertStatus = false;

    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";
    this.SearchTypeView = "";

    this.TINInput = "";
    this.AgentInput = "";
    this.SearchTypeInput = "";
  }
  openWindow(URL: any) {
    if (this.openedWindowStatus === null || this.openedWindowStatus.closed)
      this.openedWindowStatus = window.open(URL, "_blank");
    else
      this.openedWindowStatus.focus();
  }
}
